// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"150":"0b5a5798","202":"3f5e3b6c","572":"41528211","788":"ac518b92"}[chunkId] + ".chunk.css";
};